import {Injectable} from "@angular/core";
import {Http, URLSearchParams} from "@angular/http";
import {Observable} from "rxjs/Rx";
import {UrlService} from "../url.service";
import {AuthentService} from "../authent.service";
import {FamiliesService} from "../families.service";
import {BusinessGlobalStats, BusinessDatedStats} from "../../model/business-stats";

@Injectable()
export class StatsService extends FamiliesService {

    constructor(private http:Http, private urlService:UrlService, private authent:AuthentService) {
        super();
    }

    getBusinessGlobalStats(businessId:number):Observable<BusinessGlobalStats> {
        return this.http.get(this.urlService.getGlobalStatsUrl(businessId), this.authent.getJSONAuthentHeaders())
            .map(this.extractData)
            .catch(this.handleError);
    }

    getEventGlobalStats(eventId:number):Observable<BusinessGlobalStats> {
        return this.http.get(this.urlService.getEventGlobalStatsUrl(eventId), this.authent.getJSONAuthentHeaders())
            .map(this.extractData)
            .catch(this.handleError);
    }

    getBusinessDatedStats(businessId:number, from: number, to: number):Observable<BusinessDatedStats> {
        let params:URLSearchParams = new URLSearchParams();

        if(from!=null) {
            params.set('from', String(from));
        }

        if(to!=null) {
            params.set('to', String(to));
        }

        let options = this.authent.getJSONAuthentHeaders();
        options.search = params;

        return this.http.get(this.urlService.getDatedStatsUrl(businessId), options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getEventDatedStats(eventId:number, from: number, to: number):Observable<BusinessDatedStats> {
        let params:URLSearchParams = new URLSearchParams();

        if(from!=null) {
            params.set('from', String(from));
        }

        if(to!=null) {
            params.set('to', String(to));
        }

        let options = this.authent.getJSONAuthentHeaders();
        options.search = params;

        return this.http.get(this.urlService.getDatedEventStatsUrl(eventId), options)
            .map(this.extractData)
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/data/stats.service.ts